import AntdTable from "antd/es/table/";

export type TableSummaryProps = React.ComponentProps<typeof AntdTable.Summary>;

const TableSummary = AntdTable.Summary;

export { TableSummary };
